// Futuristic Matrix Background
(function () {
  const katakana = 'アァカサタナハマヤャラワガザダバパイィキシチニヒミリヰギジヂビピウゥクスツヌフムユュルグズブヅプエェケセテネヘメレゲゼデベペオォコソトノホモヨョロゴゾドボポヴッン';
  const latin = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const nums = '0123456789';

  const alphabet = katakana + latin + nums;
  const fontSize = 16;

  let timer;
  let sizeObserver;
  let viewObserver;
  let onVisibility;

  const init = () => {
    const canvas = document.getElementById('matrixCanvas');
    const hero = document.getElementById('hero');
    if (!canvas || !hero) return;

    clearInterval(timer);
    if (sizeObserver) sizeObserver.disconnect();
    if (viewObserver) viewObserver.disconnect();
    document.removeEventListener('visibilitychange', onVisibility);

    const ctx = canvas.getContext('2d');
    const rainDrops = [];
    let inView = false;

    const draw = () => {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = '#00FF41'; // Green color
      ctx.font = fontSize + 'px monospace';

      for (let i = 0; i < rainDrops.length; i++) {
        const text = alphabet.charAt(Math.floor(Math.random() * alphabet.length));

        ctx.fillText(text, i * fontSize, rainDrops[i] * fontSize);

        if (rainDrops[i] * fontSize > canvas.height && Math.random() > 0.97) {
          rainDrops[i] = 0;
        }
        rainDrops[i]++;
      }
    };

    // Only animate while the hero is on screen and the tab is visible
    const update = () => {
      clearInterval(timer);
      timer = null;
      if (inView && !document.hidden && canvas.width > 0) {
        timer = setInterval(draw, 30);
      }
    };

    // The observers report the hero's size and visibility without forcing a layout,
    // unlike reading offsetHeight
    sizeObserver = new ResizeObserver((entries) => {
      const box = entries[0].borderBoxSize && entries[0].borderBoxSize[0];
      const width = Math.round(box ? box.inlineSize : hero.offsetWidth);
      const height = Math.round(box ? box.blockSize : hero.offsetHeight);
      if (canvas.width === width && canvas.height === height) return;

      canvas.width = width;
      canvas.height = height;

      const columns = canvas.width / fontSize;
      for (let x = rainDrops.length; x < columns; x++) {
        rainDrops[x] = 1;
      }
      update();
    });
    sizeObserver.observe(hero);

    viewObserver = new IntersectionObserver((entries) => {
      inView = entries[0].isIntersecting;
      update();
    });
    viewObserver.observe(hero);

    onVisibility = update;
    document.addEventListener('visibilitychange', onVisibility);
  };

  init();

  // The theme editor swaps the hero's markup in place, which leaves a blank canvas
  document.addEventListener('shopify:section:load', init);
})();
